//Fix for global styles overwrite from search-pages.less
var inputStyles = {
  height: '32px !important',
  'csg-tui-input-wrapper': {
    height: '32px !important'
  },
  'csg-tui-text-input': {
    height: '32px !important'
  }
};
//Global Styling overwrite
var buttonStyles = {
  '.csg-tui-button[disbled]': {
    opacity: 1
  }
};

export { buttonStyles, inputStyles };
//# sourceMappingURL=shared-style.esm.js.map
